module.exports = __webpack_public_path__ + "media/images/contest_img-676428be7998d72c3707318d7284c60e.svg";